<template>
  <div class="content-block">
    <div class="dep-edit-block">
      <div class="dep-edit-block__title">
        {{ $t('orgs.name_org') }}
      </div>
      <template v-if="!collapseVisible.name">
        <div class="dep-edit-block__full-name">
          {{org.getName()}}
        </div>
      </template>
      <div class="dep-edit-block__collapse-link" v-if="!collapseVisible.name">
            <span @click="collapseVisible.name = !collapseVisible.name, showCurrentData()">
                  {{ $t('labels.change') }}
            </span>
      </div>
      <div v-if="collapseVisible.name" class="dep-edit-block__collapse-item">
        <el-input v-bind:class="{ showLabel: name || error.name.invalid, error: error.name.invalid }"
                  class="dep-edit-block__input"
                  :placeholder="$t('orgs.name_org')"
                  v-model="name"
                  @blur="capitalize('name')"
                  @input="resetError('name')">
          <label v-if="error.name.invalid"
                 class="label-error"
                 slot="prefix">
            {{ error.name.message }}
          </label>
          <label v-else
                 slot="prefix">{{ $t('orgs.name_org') }}</label>
        </el-input>
        <el-button @click="setName" type="primary">{{ $t('labels.save') }}</el-button>
        <el-button @click="collapseVisible.name = !collapseVisible.name">{{ $t('labels.cancel') }}</el-button>
      </div>
    </div>

    <div class="dep-edit-block">
      <div class="dep-edit-block__title">
        {{ $t('labels.short_title') }}
      </div>
      <template v-if="!collapseVisible.abbr">
        <div class="dep-edit-block__full-name">
          {{org.getAbbr()}}
        </div>
      </template>
      <div class="dep-edit-block__collapse-link" v-if="!collapseVisible.abbr">
            <span @click="collapseVisible.abbr = !collapseVisible.abbr, showCurrentData()">
                  {{ $t('labels.change') }}
            </span>
      </div>
      <div v-if="collapseVisible.abbr" class="dep-edit-block__collapse-item">
        <el-input v-bind:class="{ showLabel: abbr || error.abbr.invalid, error: error.abbr.invalid }"
                  class="dep-edit-block__input"
                  :placeholder="$t('orgs.name_org')"
                  v-model="abbr"
                  @input="resetError('abbr')">
          <label v-if="error.abbr.invalid"
                 class="label-error"
                 slot="prefix">
            {{ error.abbr.message }}
          </label>
          <label v-else
                 slot="prefix">{{ $t('labels.short_title') }}</label>
        </el-input>
        <el-button @click="setAbbr" type="primary">{{ $t('labels.save') }}</el-button>
        <el-button @click="collapseVisible.abbr = !collapseVisible.abbr">{{ $t('labels.cancel') }}</el-button>
      </div>
    </div>

    <!-- <div class="dep-edit-block">
      <div class="dep-edit-block__title">
        {{ $t('orgs.director') }}
      </div>
      <template v-if="!collapseVisible.chief">
        <div class="dep-edit-block__data-row-value">
              <span v-if="chiefData">
                <span v-if="chiefData.last_name">{{ chiefData.last_name }}</span>
                <span v-if="chiefData.first_name">{{ chiefData.first_name }}</span>
                <span v-if="chiefData.middle_name">{{ chiefData.middle_name }}</span>
              </span>
          <span v-else>{{ $t('labels.not_specified3') }}</span>
        </div>
      </template>
      <div class="dep-edit-block__collapse-link" v-if="!collapseVisible.chief">
            <span @click="collapseVisible.chief = !collapseVisible.chief, showCurrentData()">
                  {{ $t('labels.change') }}
            </span>
        <span v-if="org.getChief()" @click="deleteChief()">
                  {{ $t('labels.delete') }}
            </span>
      </div>
      <div v-if="collapseVisible.chief">
        <chief-find @selected="setChief($event)"></chief-find>
        <el-button @click="collapseVisible.chief = false">{{ $t('labels.cancel') }}</el-button>
      </div>
    </div> -->

    <div class="dep-edit-block">
      <div class="dep-edit-block__title">
        {{ $t('orgs.is_part_of') }}
      </div>
      <template v-if="isHeadOrg()">
        <template v-if="!collapseVisible.parent">
          <div class="dep-edit-block__data-row-value">
            <org-name :orgId="org.getParentId()" ref="depName" showParent></org-name>
          </div>
          <div class="dep-edit-block__collapse-link" v-if="!collapseVisible.parent">
            <span @click="collapseVisible.parent = !collapseVisible.parent"
            >
                  {{ $t('labels.change') }}
            </span>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="dep-edit-block__data-row-value">{{ $t('orgs.head_org') }}</div>
        <div class="dep-edit-block__collapse-link" v-if="!collapseVisible.parent">
          <span @click="collapseVisible.parent = !collapseVisible.parent"
          >
                {{ $t('labels.change') }}
          </span>
        </div>
      </template>
      <div v-if="collapseVisible.parent" class="dep-edit-block__collapse-item">
        <tree-select @checked="setParentNode"
                     @showPopover="getDepList"
                     :placeholder="$t('labels.organization_structure')"
                     :data="depList"
                     nodeKey="id"
                     ref="tree"
                     :disabled="isHeadOrgChecked"
                     >
        </tree-select>
        <div class="my">
          <el-switch 
            :value="isHeadOrgChecked"
            :active-text="$t('orgs.top_level_org')"
            @change="onHeadOrgChanged"
          ></el-switch>
        </div>
        <el-button @click="setParent" type="primary">{{ $t('labels.save') }}</el-button>
        <el-button @click="collapseVisible.parent = !collapseVisible.parent, parent = ''">{{ $t('labels.cancel') }}</el-button>
      </div>
    </div>

    <div class="dep-edit-block">
      <el-button class="dep-edit-delete" type="text" icon="el-icon-delete" @click="deleteOrg">{{ $t('orgs.subdivision_delete') }}
      </el-button>
    </div>
  </div>
</template>
<script>
import orgName from 'src/components/Orgs/OrgName.vue'
// import getDepartmentList from '@/services/departmentList'
import ChiefFind from '../OrgCreate/chiefFind';
import TreeSelect from 'src/components/TreeSelect/TreeSelect.vue'
import _ from 'lodash'
import capitalize from 'src/filters/capitalize'

export default {
  props: {
    org: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    ChiefFind,
    orgName,
    TreeSelect
  },
  data () {
    return {
      isHeadOrgChecked: false,
      name: '',
      abbr: '',
      chief: '',
      parent: '',
      help_conditions: '',
      org_profile: '',
      chiefData: '',
      org_public: false,
      query: {
        first_name: null,
        last_name: null,
        middle_name: null
      },
      depList: [],
      orgsMap: {},
      collapseVisible: {
        name: false,
        abbr: false,
        chief: false,
        parent: false,
        help_conditions: false,
        org_profile: false,
        org_public: false
      },
      error: {
        name: {
          invalid: false,
          message: ''
        },
        abbr: {
          invalid: false,
          message: ''
        }
      }
    }
  },
  methods: {
    onHeadOrgChanged () {
      this.isHeadOrgChecked = !this.isHeadOrgChecked
    },
    capitalize (path) {
      this[path] = capitalize(this[path])
    },
    showCurrentData () {
      this.name = this.org.getName()
      this.abbr = this.org.getAbbr()
      this.chief = this.org.getChief()
    },
    isHeadOrg () {
      if (this.org.getParentId()) {
        return true;
      }
    },
    async loadChief () {
      /* if (this.org.blocks.info.chief && this.org.getChief()) {
        let {users} = await admin.getUserInfo(this.org.getChief());
        if (users && Array.isArray(users) && users[0]) {
          this.chiefData = users[0];
        }
      } */
    },
    async getDepList () {
      try {
        let list = await this.$store.dispatch('orgs/loadRawOrgList')
        let tree = this.$store.getters['orgs/getRawTree'](list)
        this.depList = tree;
        this.createOrgMap(this.depList)
      } catch (error) {
        console.error('LOG: getDepList -> error', error)
      }
    },
    createOrgMap (tree) {
      let map = {}

      function findOrg (orgs) {
        for (let org of orgs) {
          map[org.id] = org
          if (org.children && org.children.length) {
            findOrg(org.children)
          }
        }
      }

      findOrg(tree)
      this.orgsMap = map
    },
    setParentNode (data, checked) {
      console.log('LOG: setParentNode -> checked', checked)
      console.log('LOG: setParentNode -> data', data)
      let self = this;

      function isParentOrg () {
        let childrenIds = [];

        function addId (children) {
          console.log('LOG: addId -> children', children)
          if (children) {
            for (let child of children) {
              childrenIds.push(child.id)
              if (child.children && child.children.length) {
                addId(child.children)
              }
            }
          }
        }

        addId(self.orgsMap[self.org.getId()].children)
        if (childrenIds.some(id => id === data.id)) {
          return true;
        } else {
          return false;
        }
      }

      if (this.org.getId() === data.id || isParentOrg()) {
        let self = this
        this.$message({
          message: this.$t('orgs.org_can_not_added_to_himself'),
          type: 'warning'
        });
        setTimeout(() => {
          self.$refs.tree.reset()
        }, 2000)
      } else {
        this.parent = data.id
      }
    },
    setError (key, message) {
      this.error[key].invalid = true;
      this.error[key].message = message;
    },
    resetError (keys) {
      if (keys) {
        let arr = keys.split(', ')
        for (let key of arr) {
          this.error[key].invalid = false;
          this.error[key].message = '';
        }
      } else {
        let error = this.error;

        for (let item in error) {
          this.error[item].invalid = false;
          this.error[item].mesage = '';
        }
      }
    },
    async orgUpdate (field) {
      try {
        await this.$store.dispatch('orgs/updateOrg', {
          org_id: this.org.getId(),
          ...field
        })
        this.$emit('updateData')
        this.hideCollapse()
      } catch (e) {
        this.$emit('error')
      }
    },
    hideCollapse () {
      this.collapseVisible = {
        name: false,
        abbr: false,
        chief: false,
        parent: false,
        help_conditions: false,
        org_profile: false
      }
    },
    validateName () {
      if (!this.name) {
        this.setError('name', this.$t('labels.required_field'))
      } else {
        return true
      }
    },
    validateAbbr () {
      if (!this.abbr) {
        this.setError('abbr', this.$t('labels.required_field'))
      } else {
        return true
      }
    },
    setName () {
      if (this.validateName()) {
        let data = {
          name: this.name
        }
        this.orgUpdate(data);
      }
    },
    setAbbr () {
      if (this.validateAbbr()) {
        let data = {
          abbr: this.abbr
        }
        this.orgUpdate(data);
      }
    },
    setChief (chief) {
      if (chief) {
        let data = {
          info: {
            chief: chief._id
          }
        }
        this.orgUpdate(data)
      } else {
        this.clearQuery()
        this.collapseVisible.chief = false;
      }
    },
    deleteChief () {
      this.$confirm(this.$t('orgs.user_would_delete_from_director_position'), `${this.$t('orgs.delete_director')}?`, {
        confirmButtonText: this.$t('labels.delete'),
        cancelButtonText: this.$t('labels.cancel'),
        customClass: 'delete-modal'
      }).then(() => {
        this.setChief({_id: ''})
      }).catch(() => {
        this.$message({
          type: 'info',
          // @ts-ignore
          message: this.$t('employees.delete_canceled')
        });
      });
    },
    async setParent () {
      if (this.isHeadOrgChecked) {
        this.parent = ''
      }

      try {
        await this.$store.dispatch('orgs/setParent', {org_id: this.org.getId(), parent_id: this.parent})
        this.$emit('updateData')
        this.hideCollapse()
        this.getDepList()
      } catch (error) {
        console.error('LOG: setParent -> error', error)
        this.$emit('onError')
      }
    },
    async deleteOrg (id, name) {
      let children = await this.$store.dispatch('orgs/byParent', this.org.getId())
      if (children && children.length) {
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          message: this.$t('orgs.can_not_delete_org_with_subdivision'),
          type: 'warning',
          offset: 75,
          duration: 10000
        })
      } else {
        this.$confirm(this.org.getName(), `${this.$t('orgs.subdivision_delete')}?`, {
          confirmButtonText: this.$t('labels.delete'),
          cancelButtonText: this.$t('labels.cancel'),
          customClass: 'delete-modal'
        }).then(() => {
          this.$store.dispatch('orgs/removeOrg', this.org.getId()).then(data => {
            this.$message({
              type: 'success',
              message: this.$t('orgs.subdivision_deleted')
            });
            this.$router.push({name: 'orgs'})
          }).catch(() => {
            this.$message({
              type: 'warning',
              message: this.$t('orgs.delete_error')
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            // @ts-ignore
            message: this.$t('employees.delete_canceled')
          });
        });
      }
    }
  },
  computed: {
    // isSuperAdmin: self => self.$store.state.users.user.isSuperAdmin()
  },
  mounted () {
    this.loadChief()
    this.getDepList()
  },
  watch: {
    org: {
      handler: function () {
        this.loadChief();
        setTimeout(() => {
          this.$refs.depName.update()
        }, 100)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';
  .my {
    margin-top: 1em;
    margin-bottom: 2em;
  }
  .dep-edit-block {
    .el-input--prefix .el-input__inner {
      padding-left: 15px !important;
    }
  }

  .dep-edit-chief-serach {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 20px;

    &__wrapp {
      max-width: 400px;
    }

    &__label {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: 700;
    }

    &__inputs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 15px;
      grid-row-gap: 15px;
      margin-bottom: 30px;

      @media (max-width: $screen-sm) {
        grid-template-columns: 1fr;
      }
    }

    &__button {
      text-align: right;
    }

    &__cancel {
      display: none;
      margin-left: 10px;
      color: $link-color;

      @media (max-width: $screen-sm) {
        display: inline-block;
      }
    }

    &__clear {
      color: $link-color;
      cursor: pointer;
    }
  }

  .dep-edit-chief-list {
    margin: 20px 0;

    &__label {
      margin-bottom: 10px;
      font-weight: 700;
    }

    .el-table__row {
      cursor: pointer;
    }
  }

  .tree-select {
    margin-bottom: 15px;
  }

  .dep-edit-delete {
    color: #FF3738 !important;
  }

  .dep-edit-switcher {
    margin-bottom: 25px;
    color: #a2a2a2;
    display: grid;
    grid-template-columns: 45px 1fr;
    grid-column-gap: 10px;

    &.active {
      color: #3e3e3e;
    }

    &__text {
      cursor: pointer;
    }
  }
</style>